import { render, staticRenderFns } from "./diapositiva-5.vue?vue&type=template&id=15516deb&scoped=true&"
import script from "./diapositiva-5.vue?vue&type=script&lang=js&"
export * from "./diapositiva-5.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-5.vue?vue&type=style&index=0&id=15516deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15516deb",
  null
  
)

export default component.exports